// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"6e9c88ba","151":"65f6a23f","400":"b9d37c52","482":"19795358","784":"d7228f8b","918":"5c852e69","928":"47b6d46d"}[chunkId] + ".chunk.js";
};